export enum CarrierCode {
  BOUTIQUE = 'boutique',
  CHRONOPOST = 'chronopost',
  CHRONOPOST_EIYOLAB = 'chronopost_eiyo',
  CHRONOPOST_PICKUP = 'chronopost_pickup',
  CHRONOPOST_PICKUP_TLN = 'chronopost_pickup_tln',
  CHRONOPOST_TLN = 'chronopost_tln',
  COLIS_PRIVE = 'colis_prive',
  COLIS_PRIVE_PICKUP = 'colis_prive_pickup',
  COLIS_PRIVE_PICKUP_TLN = 'colis_prive_pickup_tln',
  COLIS_PRIVE_TLN = 'colis_prive_tln',
  DACHSER = 'dachser',
  DPD_HOME = 'dpd_domicile_terravita',
  DPD_PICKUP = 'dpd_pickup',
  MONDIAL_RELAY = 'mondial_relay',
  MONDIAL_RELAY_EIYOLAB = 'mondial_relay_eiyo',
  MONDIAL_RELAY_TLN = 'mondial_relay_tln',
}

export const CarrierTranslation: Record<CarrierCode, string> = {
  [CarrierCode.BOUTIQUE]: 'Boutique',
  [CarrierCode.CHRONOPOST]: 'Chronopost',
  [CarrierCode.CHRONOPOST_EIYOLAB]: 'Chronopost EIYOLAB',
  [CarrierCode.CHRONOPOST_PICKUP]: 'Chronopost Pickup',
  [CarrierCode.CHRONOPOST_PICKUP_TLN]: 'Chronopost Pickup TLN',
  [CarrierCode.CHRONOPOST_TLN]: 'Chronopost TLN',
  [CarrierCode.COLIS_PRIVE]: 'Colis Prive',
  [CarrierCode.COLIS_PRIVE_PICKUP]: 'Colis Prive Pickup',
  [CarrierCode.COLIS_PRIVE_PICKUP_TLN]: 'Colis Prive Pickup TLN',
  [CarrierCode.COLIS_PRIVE_TLN]: 'Colis Prive TLN',
  [CarrierCode.DACHSER]: 'Dachser',
  [CarrierCode.DPD_HOME]: 'DPD',
  [CarrierCode.DPD_PICKUP]: 'DPD Pickup',
  [CarrierCode.MONDIAL_RELAY]: 'Mondial Relay',
  [CarrierCode.MONDIAL_RELAY_EIYOLAB]: 'Mondial Relay EIYOLAB',
  [CarrierCode.MONDIAL_RELAY_TLN]: 'Mondial Relay TLN',
};

export type CarrierSelect = {
  label: string;
  code: CarrierCode;
  value: number;
};
